/// <reference path="../../_ext/Bases/TransDialog.ts" />
namespace TabAurous.Inventory {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    export class RejectionDialog extends _Ext.TransDialog<RejectionRow, any> {
        protected getFormKey() { return RejectionForm.formKey; }
        protected getIdProperty() { return RejectionRow.idProperty; }
        protected getLocalTextPrefix() { return RejectionRow.localTextPrefix; }
        protected getNameProperty() { return RejectionRow.nameProperty; }
        protected getService() { return RejectionService.baseUrl; }
        protected getDeletePermission() { return RejectionRow.deletePermission; }
        protected getInsertPermission() { return RejectionRow.insertPermission; }
        protected getUpdatePermission() { return RejectionRow.updatePermission; }

        protected useViewMode() { return true; }
        public form = new RejectionForm(this.idPrefix);
        statement: string;
        static image: string;
        contractTotals: string;
        TaxArray: any[];
        public Closing: boolean;

        constructor() {
            super();

            var Config = Q.deepClone(q.DefualtEditorOptions);
            Config.height = 290;
            q.initItemEditor(this, this.form.ItemDetails, Config);
            //Make grid full width
            q.hideEditorLabel(this.form.ItemDetails);
            //q.hideEditorLabel(this.form.TaxDetails);
            q.setTextRightAlign(this.form.NetAmount);
            q.setTextRightAlign(this.form.AdditionalCharges);
            q.setTextRightAlign(this.form.GrossAmount);
            q.setTextRightAlign(this.form.Discount);
            q.setTextRightAlign(this.form.Pieces);
            q.setTextRightAlign(this.form.Weight);
            q.setTextRightAlign(this.form.NetWeight);
            q.setTextRightAlign(this.form.ExchRate);
            // q.setTextRightAlign(this.form.TaxAmount);
            q.setGridEditorHeight(this.form.ItemDetails, 300);
            //To Hide Image Toolbar & Label
            q.hideImageToolbar(this.form.ProductItemImage);
            q.hideEditorLabel(this.form.ProductItemImage);
            //q.hideCaption(this.form.Posted);

            //To Show Image on Right Top & Hide Categories
            q.SetCategorySixColumn(this.form.TransDate);
            q.SetCategoryFourColumn(this.form.BillNo);
            q.SetCategoryFullWidth(this.form.ItemDetails);
            q.SetSix12Column(this.form.FinancialYearId);
            q.SetCategoryTwoColumn(this.form.Pieces);
            q.SetCategoryFourColumn(this.form.NetAmount);
            q.SetCategoryFullWidth(this.form.Remark);
            q.HideCategoryLable(this.element);

            //q.setGridEditorHeight(this.form.TaxDetails.element, 150);
            q.hideEditorTab
            //this.form.TaxDetails.getGridField().find('.grid-toolbar').attr("style", "display:none;");
            this.form.ItemDetails.slickGrid.setOptions({ forceFitColumns: true });

            this.form.RejectionType.changeSelect2(e => {
                switch (this.form.RejectionType.value) {
                    case "1": this.form.ItemDetails.rejectionType = 1;
                        this.form.POSCustomerId.getGridField().toggle(false);
                        this.form.PartyId.getGridField().toggle(false);
                        break;
                    case "2": this.form.ItemDetails.rejectionType = 2;
                        this.form.POSCustomerId.getGridField().toggle(true);
                        this.form.PartyId.getGridField().toggle(false);
                        break;
                    case "3": this.form.ItemDetails.rejectionType = 3;
                        this.form.POSCustomerId.getGridField().toggle(false);
                        this.form.PartyId.getGridField().toggle(true);
                        break;
                    case "4": this.form.ItemDetails.rejectionType = 4;
                        this.form.POSCustomerId.getGridField().toggle(true);
                        this.form.PartyId.getGridField().toggle(false);
                        break;
                }
            });
            this.form.PartyId.changeSelect2(e => {
                this.form.ItemDetails.PartyId = parseInt(this.form.PartyId.value);
                this.form.POSCustomerId.value = "0";
            });
            this.form.POSCustomerId.changeSelect2(e => {
                this.form.ItemDetails.PartyId = parseInt(this.form.POSCustomerId.value);
                this.form.PartyId.value = "0";
            });
            // **** Get Party Details using PartyID **** 


            this.form.CurrencyId.changeSelect2(e => {
                var ExchangeDetails = OMS.ExchangeRateRow.getLookup().items.filter(x => x.CurrencyId.toString() == this.form.CurrencyId.value && x.FromDate <= this.form.TransDate.value && x.ToDate >= this.form.TransDate.value)[0];
                this.form.ExchRate.value = ExchangeDetails.ExchRate;
            });

            //this.form.DepartmentId.changeSelect2(e => {
            //    this.form.ItemDetails.DeptId = parseInt(this.form.DepartmentId.value);
            //});

            //Load Image after Row in Details is Clicked
            var _this = this;
            //this.form.ItemDetails.slickGrid.onClick.subscribe(function (e, args) {

            //    var x: Serenity.UploadedFile = {
            //        Filename: RejectionDialog.image,
            //        OriginalName: ""
            //    }
            //    _this.form.ProductItemImage.value = x;//POSSalesDialog.image;

            //    //Set Image Width & Height

            //    q.setImageEditorHeight(_this.form.ProductItemImage, 160);
            //});
            var ItemTotal = 0;
            var Items: any;



            // **** Calculate Net,Gross Amount, Discount and Tax from Item Details and show on form ****
            var ItemTotal = 0;
            var Items: any;

            (this.form.ItemDetails.view as any).onRowCountChanged.subscribe(() => {
                Items = this.form.ItemDetails.getItems();
                if (ItemTotal > 0) {
                    ItemTotal = 0;
                }

                this.CalculateAmountandTax(Items, ItemTotal);

            });

            this.form.GrossAmount.addValidationRule(this.uniqueName, x => {
                var items = this.form.ItemDetails.getItems();

                //items.forEach(function (value) {
                //    value.BOMDetails.forEach(function (bom) {
                //        if (bom.BomAmount == null || bom.BomAmount <= 0) {
                //            return "BOM must Have rate!!";
                //        }

                //    })
                //})


                if (items.length <= 0)
                    return "Select at least one item";

            });

            this.validateForm();

        } 

        private CalculateAmountandTax(Items: any, ItemTotal: number) {

            var codearray = [];
            var amtarray = [];
            var TaxDetail = [];
            var ntamt = 0; var gramt = 0; var disc = 0; var tax = 0; var pcs = 0; var wt = 0; var nwt = 0;

            //Items.forEach(function (x)
            for (var x of Items) {
                ntamt += x.NetAmount || 0;
                gramt += x.GrossAmount || 0;
                disc += x.Discount || 0;
                pcs += x.Pieces || 0;
                wt += x.Weight || 0;
                nwt += x.NetWeight || 0;

                var temp = false;
                for (let i = 0; i < codearray.length; i++) {
                    if (codearray[i] == x.HSN) {
                        amtarray[i] += x.GrossAmount || 0;
                        temp = true;
                    }
                }

                if (!temp) {
                    codearray.push(x.HSN);
                    amtarray.push(x.GrossAmount);
                }
                ItemTotal++;
            };

            this.form.NetAmount.value = gramt;
            this.form.Discount.value = disc;


            this.form.GrossAmount.value = gramt;
            this.form.Pieces.value = pcs;
            this.form.Weight.value = wt;
            this.form.NetWeight.value = nwt;



        }


        protected onDialogOpen() {
            super.onDialogOpen();
            var deptid = this.form.DepartmentId.value;
            this.form.DepartmentId.DepartmentTypeId = 2;
            this.form.DepartmentId.updateItems();
            this.form.DepartmentId.value = deptid;
            if (this.form.POSCustomerId.value != "") {

            } else {
                this.form.POSCustomerId.getGridField().toggle(false);
                this.form.PartyId.getGridField().toggle(false);
            }

            var ExchangeDetails = OMS.ExchangeRateRow.getLookup().items.filter(x => x.CurrencyId.toString() == this.form.CurrencyId.value && x.FromDate <= this.form.TransDate.value && x.ToDate >= this.form.TransDate.value)[0];
            this.form.ExchRate.value = ExchangeDetails.ExchRate;


        }

        protected getToolbarButtons(): Serenity.ToolButton[] {
            let btns = super.getToolbarButtons();

            var btnDelete = Q.first(btns, x => x.cssClass == "delete-button");

            var oldDeleteClick = btnDelete.onClick;

            btnDelete.onClick = e => { this.confirmBeforeDelete(oldDeleteClick, e); };

            //Edit Click Override
            var btnEdit = Q.first(btns, x => x.cssClass == "edit-button");
            var oldEditClick = btnEdit.onClick;
            btnEdit.onClick = e => { this.confirmBeforeEdit(oldEditClick, e); };

            //Export PDF Button
            btns.push(TabAurous.Common.ReportHelper.createToolButton({
                title: 'Invoice',
                cssClass: 'export-pdf-button',
                reportKey: 'Reports.Rejection',
                getParams: () => ({
                    TransID: this.get_entityId()
                })
            }));
            var postingpermission = Q.Authorization.hasPermission('Inventory:RejectionIn:Posting');
            //Export PDF Button
            btns.push({
                title: 'Post',
                icon: 'las la-check-double',
                cssClass: 'approve-doc-button',
                onClick: () => {
                    var entity = this.entity;
                    entity.AutoPosting = true; delete entity.TransDate;
                 
                    RejectionService.Update({ Entity: entity, EntityId: entity.TransId }, response => {
                        if (response.Error == null) {
                            this.dialogClose();
                            Serenity.SubDialogHelper.triggerDataChange(this);
                        }
                    }, { async: false })
                },
                visible: postingpermission

            });

            return btns;
        }
        // **** Validate Reference of Voucher in Stock Transaction Before Edit. ****
        private confirmBeforeEdit(oldEvt, e) {
            let self = this;
            let refid: Stock.StockItemRow;
            Stock.StockItemService.CheckTransaction(
                { RefTransId: parseInt(this.form.TransId.value), RefVoucherId: this.form.VoucherTypeId.value },
                response => {
                    if (response.Entities != null && response.Entities.length > 0)
                        refid = response.Entities[0];
                }, { async: false }
            )
            if (refid != null) {
                if (refid.PartyId != null || refid.PartyId > 0) {
                    Q.alert("This Voucher has been used in transactions Can Not Delete!");
                    return;
                }
            } else {
                Serenity.EditorUtils.setReadonly(this.form.ItemDetails.element, false);
                this.form.ItemDetails.canUpdate = 1;
                if (!self.isEditMode())
                    return;
                self.editClicked = true;
                self.updateInterface();
                self.updateTitle();
            }
        }

        // **** Validate Reference of Voucher in Stock Transaction Before Delete. ****
        private confirmBeforeDelete(oldEvt, e) {
            let self = this;
            let refid: Stock.StockItemRow;
            Stock.StockItemService.CheckTransaction(
                { RefTransId: parseInt(this.form.TransId.value), RefVoucherId: this.form.VoucherTypeId.value },
                response => {
                    if (response.Entities != null && response.Entities.length > 0)
                        refid = response.Entities[0];
                }, { async: false }
            )

            if (refid != null) {
                if (refid.PartyId != null || refid.PartyId > 0) {
                    Q.alert("This Voucher has been used in transactions Can Not Delete!");
                    return;
                }
            } else {
                RejectionService.Delete(
                    {
                        EntityId: this.entityId
                    }, response => {
                        Serenity.SubDialogHelper.triggerDataChange(self);
                        self.dialogClose();
                        window.setTimeout(() => Q.notifySuccess(Q.text('Deleted successfully')), 0);
                    });
            }

        } 
    }
}